// src/services/financeService.js
// Wraps /api/finance/* and /api/sales/reps backend calls.
// Added: createCommissionFromContract method.

import { api } from './api';

export const financeService = {
  // Contracts
  getContracts: (clientName) =>
    api.get('/api/finance/contracts' + (clientName ? '?client_name=' + encodeURIComponent(clientName) : '')),

  getContract: (contractId) =>
    api.get('/api/finance/contracts/' + contractId),

  createContract: (data) =>
    api.post('/api/finance/contracts', data),

  updateContract: (contractId, data) =>
    api.put('/api/finance/contracts/' + contractId, data),

  // Feature: end an active contract before its natural end date.
  endContract: (contractId, data) =>
    api.put('/api/finance/contracts/' + contractId + '/end', data),

  deleteContract: (contractId) =>
    api.delete('/api/finance/contracts/' + contractId),

  // Contract Document (uploaded at creation, or afterwards) — stored on R2
  uploadContractDocument: (contractId, data) =>
    api.post('/api/finance/contracts/' + contractId + '/upload-document', data),

  getContractDocumentPreviewUrl: (contractId) => {
    const token = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
    return (
      baseUrl + '/api/finance/contracts/' + contractId +
      '/document?preview=1&token=' + encodeURIComponent(token)
    );
  },

  downloadContractDocument: async (contractId, filename) => {
    const token = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
    const response = await fetch(
      baseUrl + '/api/finance/contracts/' + contractId + '/document',
      { headers: { Authorization: 'Bearer ' + token } }
    );
    if (!response.ok) {
      throw new Error('Failed to download document');
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename || 'document';
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  // Milestones
  addMilestone: (contractId, data) =>
    api.post('/api/finance/contracts/' + contractId + '/milestones', data),

  updateMilestone: (contractId, milestoneId, data) =>
    api.put('/api/finance/contracts/' + contractId + '/milestones/' + milestoneId, data),

  markMilestoneReceived: (contractId, milestoneId, data) =>
    api.put('/api/finance/contracts/' + contractId + '/milestones/' + milestoneId + '/mark-received', data),

  getOverdueMilestones: () =>
    api.get('/api/finance/milestones/overdue'),

  getUpcomingMilestones: (days) =>
    api.get('/api/finance/milestones/upcoming?days=' + (days || 7)),

  // Invoices (SRS 4.2.3)
  getInvoices: (contractId) =>
    api.get('/api/finance/invoices' + (contractId ? '?contract_id=' + contractId : '')),

  generateInvoice: (contractId, milestoneId) =>
    api.post('/api/finance/invoices/generate', { contract_id: contractId, milestone_id: milestoneId }),

  getInvoiceDownloadUrl: (invoiceId) =>
    '/api/finance/invoices/' + invoiceId + '/download',

  sendInvoice: (invoiceId, toEmail) =>
    api.post('/api/finance/invoices/' + invoiceId + '/send?to_email=' + encodeURIComponent(toEmail)),

  // Commission directly contract se create karo (SRS SAL-02)
  // Lead_id ho ya na ho — dono cases backend handle karta hai
  createCommissionFromContract: (contractId) =>
    api.post('/api/finance/contracts/' + contractId + '/create-commission', {}),

  // Sales reps lookup
  getSalesReps: () =>
    api.get('/api/sales/reps'),
};